import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import useStyles from '../NewsManagement/index.style';
import PropTypes from 'prop-types';
import { Add } from '@material-ui/icons';
import { useHistory } from 'react-router';
import { setNewsFilterType } from 'redux/actions/NewsManager';
import { useDispatch, useSelector } from 'react-redux';
import CmtSearch from '@coremat/CmtSearch';

const NewsItemHeader = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { newsFilterType } = useSelector(({ news }) => news);
  const { searchText } = newsFilterType;

  const handleSearchText = e => {
    dispatch(setNewsFilterType({ by_title: e.target.value, page: 1 }));
  };

  return (
    <Box className={classes.inBuildAppHeader}>
      <Box className={classes.inBuildAppHeaderSidebar}>
        <Typography className={classes.inBuildAppHeaderTitle} component="div" variant="h1">
          جدول اخبار
        </Typography>
      </Box>

      <Box className={classes.inBuildAppHeaderContent}>
        <CmtSearch
          placeholder="جستجو..."
          value={searchText}
          defaultValue={newsFilterType?.by_title}
          onChange={handleSearchText}
          border={false}
        />
        <Box ml="auto" display="flex" alignItems="center">
          <Box ml={1}>
            <Button
              variant="contained"
              color="secondary"
              href={`/news-management`}
              endIcon={<Add />}>
              خبر جدید
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NewsItemHeader;

NewsItemHeader.prototype = {
  onChangeViewMode: PropTypes.func,
};
